import React from "react";
import Select, { components } from "react-select";

const VALOR_TODOS = "__todos__";

// Primera fila del menú: botón para marcar o quitar todas las opciones de una vez.
const MenuList = (props) => {
    const { onToggleAll, todosSeleccionados, textoSeleccionarTodo, textoQuitarSeleccion } = props.selectProps;
    return (
        <components.MenuList {...props}>
            <div style={{ padding: "4px 8px", borderBottom: "1px solid #e5e7eb" }}>
                <button
                    type="button"
                    className="btn btn-link p-0 font-gothan-medium"
                    style={{ fontSize: "13px" }}
                    onMouseDown={(e) => e.preventDefault()}
                    onClick={onToggleAll}>
                    {todosSeleccionados ? textoQuitarSeleccion : textoSeleccionarTodo}
                </button>
            </div>
            {props.children}
        </components.MenuList>
    );
};

const Option = (props) => (
    <components.Option {...props}>
        <input type="checkbox" checked={props.isSelected} onChange={() => null} style={{ marginRight: "8px", accentColor: "#1403fa" }} />
        <label className="mb-0">{props.label}</label>
    </components.Option>
);

/**
 * Selección múltiple con botón "Seleccionar todo". `selectedValues` es la lista de valores marcados
 * ([] = ninguno). Cuando están todos marcados se muestra una sola etiqueta ("Todas").
 */
const MultiSelectAllInput = ({
    options = [],
    selectedValues = [],
    setSelectedValues,
    isDisabled = false,
    placeholder = "Seleccionar",
    textoTodos = "Todas",
    textoSeleccionarTodo = "Seleccionar todo",
    textoQuitarSeleccion = "Quitar selección",
    isLoading = false
}) => {
    const todosSeleccionados = options.length > 0 && options.every((o) => selectedValues.includes(o.value));

    const valorMostrado = todosSeleccionados
        ? [{ value: VALOR_TODOS, label: textoTodos }]
        : options.filter((o) => selectedValues.includes(o.value));

    const onToggleAll = () => setSelectedValues(todosSeleccionados ? [] : options.map((o) => o.value));

    const handleChange = (selected, meta) => {
        // Quitar la etiqueta "Todas" equivale a limpiar la selección.
        if (meta?.removedValue?.value === VALOR_TODOS || meta?.action === "clear") {
            setSelectedValues([]);
            return;
        }
        setSelectedValues(Array.isArray(selected) ? selected.map((x) => x.value).filter((v) => v !== VALOR_TODOS) : []);
    };

    return (
        <Select
            isMulti
            isClearable
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            isDisabled={isDisabled}
            isLoading={isLoading}
            placeholder={placeholder}
            noOptionsMessage={() => "Sin opciones"}
            options={options}
            value={valorMostrado}
            onChange={handleChange}
            components={{ MenuList, Option }}
            menuPosition="fixed"
            onToggleAll={onToggleAll}
            todosSeleccionados={todosSeleccionados}
            textoSeleccionarTodo={textoSeleccionarTodo}
            textoQuitarSeleccion={textoQuitarSeleccion}
        />
    );
};

export default MultiSelectAllInput;
